import React, { useState } from "react";
import PropTypes from "prop-types";
import privateAxios from "../../../../utils/axiosPrivate";
import { showToast, formatDateWithDayjs } from "../../../../utils/utils";
import { getClientStatusUserURL } from "../../../../utils/constants/apiEndPoints";
import { getClientStatusOptions } from "../../../../utils/getDropdownOptions";
import useHasPermissionApi from "../../../../hooks/useHasPermissionApi";
import {
  APPROVED_CUSTOMERS,
  showToastType,
  STATUS_2,
  USER_STATUS_APPROVED,
  USER_STATUS_PRE_APPROVED,
  TRACK_CUSTOM
} from "../../../../utils/constants/appConstants";
import { toastText, metaPixel } from "../../../../locales/en";

const StatusCell = ({ value, row }) => {
  const [isStatus, setIsStatus] = useState(value || "");
  const { checkPermission } = useHasPermissionApi();

  const handleStatusUpdate = async (event) => {
    const newValue = event.target.value;

    if (newValue === STATUS_2) {
      const permissionData = await checkPermission(APPROVED_CUSTOMERS);
      if (!permissionData?.hasPermissionWithFullAccess) {
        showToast(toastText.permissionDenied, showToastType.error);
        return;
      }
    }

    setIsStatus(newValue);

    try {
      const datatoSend = { userStatusId: newValue };
      const response = await privateAxios.put(
        getClientStatusUserURL(row.original.id),
        datatoSend
      );

      if (response.status === 200) {
        showToast(response.data.message, showToastType.success);
        // TODO this conversion is misattributed. It fires in the admin's browser, so Meta
        // matches it to the staff member rather than the customer. It belongs on the
        // server-side conversion endpoint (POST /api/v1/int/conversions in
        // integration-service), reported from the service that performs the status change.
        if (Number(newValue) === USER_STATUS_APPROVED && window.fbq) {
          window.fbq(TRACK_CUSTOM, metaPixel.approved);
        } else if (
          Number(newValue) === USER_STATUS_PRE_APPROVED &&
          window.fbq
        ) {
          window.fbq(TRACK_CUSTOM, metaPixel.preApproved);
        }
      }
    } catch (error) {
      showToast(error?.response?.data?.message, showToastType.error);
    }
  };

  return (
    <select onChange={handleStatusUpdate} value={isStatus}>
      {getClientStatusOptions().map((status) => (
        <option key={status.value} value={status.value}>
          {status.label}
        </option>
      ))}
    </select>
  );
};

StatusCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
    }).isRequired
  }).isRequired
};

export const COLUMNS = [
  {
    Header: "CUSTOMER",
    Footer: "CUSTOMER",
    accessor: "displayName",
    Cell: ({ row }) => row.original.displayName?.trim() || row.original.fullName
  },
  {
    Header: "STATUS",
    Footer: "STATUS",
    accessor: "userStatusId",
    Cell: StatusCell
  },
  {
    Header: "ACC.",
    Footer: "ACC.",
    accessor: "isAccountingSoftwareConnected"
  },
  {
    Header: "INV. SUB.",
    Footer: "INV. SUB.",
    accessor: "hasSubmittedInvoice"
  },
  {
    Header: "USER",
    Footer: "USER",
    accessor: "fullName"
  },
  {
    Header: "CUSTOMER TYPE",
    Footer: "CUSTOMER TYPE",
    accessor: "signupSource"
  },
  {
    Header: "CREDIT LIMIT",
    Footer: "CREDIT LIMIT",
    accessor: "creditLimit"
  },
  {
    Header: "FUNDED INVS",
    Footer: "FUNDED INVS",
    accessor: "totalFundedInvoices"
  },
  {
    Header: "FUNDED DUE",
    Footer: "FUNDED DUE",
    accessor: "totalFundedDue"
  },
  {
    Header: "LAST LOGIN",
    Footer: "LAST LOGIN",
    accessor: "lastLoginAt",
    Cell: ({ value }) => formatDateWithDayjs(value, "DD-MMM-YYYY")
  }
];
